<template>
	<div class="delay-demo">
		<speaker-notes :notes="notes"></speaker-notes>
		<h2>Quantifying Delay</h2>
		<p>How accurate is acceptable? For music, probably about 5ms to 10ms.</p>
		<label class="delay">Delay: <input v-model="delay" type="number" step="5" min="0"> milliseconds</label>
		<music-display ref="music" :abc="tune" :has-audio="true" :options="myOptions"></music-display>
	</div>
</template>

<script>
	import MusicDisplay from "../components/MusicDisplay";
	import {formatMusic} from "../helpers/format-music";
	import { mapGetters } from 'vuex';
	import SpeakerNotes from "../components/SpeakerNotes";
	export default {
		name: "delay-demo",
		components: {MusicDisplay, SpeakerNotes},
		computed: {
			myOptions() {
				const options = Object.assign({}, this.abcjsOptions());
				options.drum= "dddd 76 77 77 77 60 30 30 30";
				options.sequenceCallback = this.sequenceCallback;
				return options;
			},
		},
		data() {
			return {
				delay: 0,
				tune: formatMusic(this.syncTune()),
				notes: [
					"Here's a demonstration of what the latency looks like.",
					"Try: 0ms, 110ms, 55ms, 10ms, 5ms.",
				]
			};
		},
		watch: {
			delay() {
				if (this.$refs.music)
					this.$refs.music.draw();
			},
		},
		methods: {
			...mapGetters(['syncTune', 'abcjsOptions']),
			sequenceCallback(seq) {
				// The measure = 1, and 150 bpm is 2.5 bps or .4 seconds per beat, so 4 beats a measure is 1.6 seconds.
				// The delay is milliseconds, so delay / 1000 is seconds, then divide by the 1.6 to get measures.
				const offset = this.delay * 1.6 / 1000;

				// Make the banjo louder
				seq[0].forEach(note => {
					note.volume = 100;
				});

				// delay the chords
				seq[1].forEach(note => {
					note.start += offset;
					note.end += offset;
				});

				// duplicate the percussion track and make it delayed.
				seq.push([]);
				seq[2].forEach(note => {
					let dup = Object.assign({}, note);
					dup.start += offset;
					dup.end += offset;
					dup.volume = 100;

					seq[3].push(dup);
				});
			},
		}
	}
</script>

<style lang="scss" scoped>
	.delay-demo {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.delay {
		text-align: left;
		margin-bottom: 20px;
		background-color: $input-background;
		box-shadow: 2px 2px 8px $input-background, -2px 2px 8px $input-background, 2px -2px 8px $input-background, -2px -2px 8px $input-background;
		padding: 10px;

		input {
			font-size: 1em;
			width: 100px;
		}
	}
</style>
